import React from 'react';
import styled from 'astroturf/react';
import { LeftArrow } from 'js/social/shared/Icons';
import {
  LinkButton,
  LinkButtonProps,
} from 'js/social/shared/design_system/LinkButton';

const Container = styled(LinkButton)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
`;

const BackButton: React.FC<LinkButtonProps> = ({ children, ...props }) => {
  return (
    <Container {...props}>
      <LeftArrow />
      {children}
    </Container>
  );
};

export default BackButton;
